export const APP_SENSITIVE_INFO_ITEMS = [
  { name: "手机号码", purpose: "注册登录、验证码、订单联系" },
  { name: "身份证号码及证件影像", purpose: "商户/技师入驻实名认证" },
  { name: "精确位置信息", purpose: "推荐附近门店、计算与门店距离、地图选点" },
  { name: "面部/舌头等身体影像照片", purpose: "头像上传、舌诊分析等您主动使用的功能" },
  { name: "收货/服务地址", purpose: "预约到店、订单履约" },
  { name: "支付与订单信息", purpose: "微信支付、支付宝支付及售后/退款处理" },
  { name: "设备标识与日志信息", purpose: "保障账号与交易安全、排查故障" },
];

const SENSITIVE_KEYWORDS = [
  "身份证号码",
  "身份证号",
  "身份证",
  "面部识别",
  "人脸信息",
  "生物识别",
  "银行账号",
  "银行卡号",
  "精确位置",
  "位置信息",
  "地理位置",
  "定位信息",
  "手机号码",
  "手机号",
  "支付信息",
  "订单信息",
  "收货地址",
  "未成年人",
  "不满十四周岁",
  "敏感个人信息",
  "个人敏感信息",
];

const HIGHLIGHT_STYLE =
  "color:#C41A1A;font-weight:700;font-size:1.15em;background:rgba(196,26,26,0.08);padding:0 4px;border-radius:2px;";

export function highlightSensitiveKeywords(html) {
  if (!html) return "";
  let out = html;
  const words = SENSITIVE_KEYWORDS.slice().sort((a, b) => b.length - a.length);

  words.forEach((word) => {
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp(escaped, "g");
    out = out.replace(re, (match, offset, full) => {
      const start = Math.max(0, offset - 120);
      const before = full.slice(start, offset);
      const lastOpen = before.lastIndexOf('<span style="' + HIGHLIGHT_STYLE);
      const lastClose = before.lastIndexOf("</span>");
      if (lastOpen !== -1 && lastOpen > lastClose) {
        return match;
      }
      const lastLt = before.lastIndexOf("<");
      const lastGt = before.lastIndexOf(">");
      if (lastLt > lastGt) {
        return match;
      }
      return `<span style="${HIGHLIGHT_STYLE}">${match}</span>`;
    });
  });

  return out;
}

export function prepareAgreementHtml(rawHtml, isPrivacyPolicy) {
  const cleaned = (rawHtml || "").replace(/<br\/>/gi, "");
  if (isPrivacyPolicy) {
    return highlightSensitiveKeywords(cleaned);
  }
  return cleaned;
}
